import * as types from '@/store/mutation-types'
import { Repository } from '@/repository/repository'
import { stripPayload } from '@/schemas'
import { services } from '@/services'

const apiRepository = Repository.call('supplier')

const state = {
  activeSuppliers: [],
  rejections: []
}

const getters = {
  activeSuppliers: state => state.activeSuppliers,
  rejections: state => state.rejections
}

const actions = {
  async getAllActiveSuppliers ({ commit }) {
    const suppliers = await apiRepository.getSuppliers()
    if (!suppliers.level) return suppliers

    const response = services.cleanResponseService(stripPayload(suppliers.data, 'supplier'))
    const activeSuppliers = response
      .sort((a, b) => a.supplierName.toUpperCase().localeCompare(b.supplierName.toUpperCase()))

    commit(types.SET_ALL_ACTIVE_SUPPLIERS, activeSuppliers)

    return suppliers
  },
  async getRejections ({ commit }) {
    const rejectionRules = await apiRepository.getRejections()
    if (!rejectionRules.level) return

    const dataStripped = services
      .cleanResponseService(
        stripPayload(rejectionRules.data, 'supplierRejectionRules')
      )
      .sort((a, b) => a.id - b.id)
    commit(types.SET_REJECTIONS, dataStripped)

    return true
  }
}

const mutations = {
  [types.SET_ALL_ACTIVE_SUPPLIERS] (state, activeSuppliers) {
    state.activeSuppliers = activeSuppliers
  },
  [types.SET_REJECTIONS] (state, rejections) {
    state.rejections = rejections
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/supplier.js